import { makeStyles } from '@material-ui/styles';
import { darkBlue, goldenDream, vividRed } from '../../../../constants/Colors';

export default makeStyles(() => ({
    root: {
        display: 'inline-flex',
        position: 'relative',
        height: 20,
        padding: '4px 12px',
        backgroundColor: ({ isValueMissing }) => (isValueMissing ? vividRed : goldenDream),
        fontSize: 15,
        color: darkBlue,
        borderRadius: '16px',
        zIndex: 3,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'padding .3s ease 0s',
        '&:hover': {
            paddingLeft: '4px',
            paddingRight: '20px',
        },
        '&:hover $icon': { visibility: 'visible' },
        '&:hover > $actions': {
            opacity: '1',
        },
    },
    actions: {
        opacity: '0',
        position: 'absolute',
        top: '5px',
        right: '7px',
    },
    icon: {
        cursor: 'pointer',
        visibility: 'hidden',
    },
    tooltip: {
        whiteSpace: 'pre',
        maxWidth: '300px',
    },
}));
